import React from 'react';
import {
    DivContainer,
    FlexDiv,
    LogoContainer,
    StyledDescription,
    StyledLink,
    StyledPartnerLogo,
    StyledSign,
} from './ErnestBiesLogo.styles';
import { WEBSITE_URL_PARTNER } from '../../../../utils/info';

const ErnestBiesLogo = ({ position, scale, mobile, resizable, style }) => {
    return (
        <LogoContainer
            style={style}
            href={WEBSITE_URL_PARTNER}
            target={'_blank'}
            title={'Ernest Bieś - strona internetowa'}
            scale={scale}
            position={position}
            mobile={mobile}
        >
            <DivContainer>
                <StyledPartnerLogo src={'/eb-logo.svg'} resizable={resizable} />
                <FlexDiv>
                    <StyledLink>{'ernestbies.com'}</StyledLink>
                    <StyledDescription>{'PROGRAMMER'}</StyledDescription>
                </FlexDiv>
            </DivContainer>
            <StyledSign>{'by Ernest Bieś'}</StyledSign>
        </LogoContainer>
    );
};

export default ErnestBiesLogo;
